import { useAuth } from '../context/AuthContext';
import { getCurrentStoreId } from '../utils/apiService';

export function useScopedQueryKey(
  baseKey: string,
  ...parts: Array<string | number | boolean | null | undefined>
) {
  const { user } = useAuth();
  const currentStoreId = getCurrentStoreId();

  return [
    baseKey,
    user?.id ?? 'anonymous',
    currentStoreId ?? 'no-store',
    ...parts,
  ];
}
